// extracted by mini-css-extract-plugin
export default {"sidebarAndBody":"SidebarAndBody_sidebarAndBody__ZKbCM"};